"use strict";
exports.__esModule = true;
var utils_1 = require("./utils");
exports["default"] = {
    please_select_time: function () { return "Bitte Zeit auswählen."; },
    start_time: function () { return "Startzeit."; },
    end_time: function () { return "Endzeit."; },
    hour: function () { return "Stunde."; },
    minute: function () { return "Minuten."; },
    second: function () { return "Sekunden."; },
    duration: {
        hour: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return "Stunde " + d.amount + " Stunde"; },
        minute: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return "Minuten " + d.amount; },
        second: function (_d) { var d = (0, utils_1.reqArgs)(["amount"], _d); return "{" + d.amount + " Sekunden"; }
    },
    dayNamesMin: {
        Su: function () { return "Der Tag"; },
        Mo: function () { return "1."; },
        Tu: function () { return "zwei"; },
        We: function () { return "drei"; },
        Th: function () { return "Vierte"; },
        Fr: function () { return "fünf"; },
        Sa: function () { return "sechs"; }
    },
    weekNamesMin: {
        Su: function () { return "Sonntag."; },
        Mo: function () { return "Der Montag"; },
        Tu: function () { return "Dienstag."; },
        We: function () { return "Mittwoch"; },
        Th: function () { return "Donnerstag sein."; },
        Fr: function () { return "Freitag"; },
        Sa: function () { return "Der Samstag"; }
    },
    monthNamesShort: {
        Jan: function () { return "im Januar"; },
        Feb: function () { return "im Februar"; },
        Mar: function () { return "März"; },
        Apr: function () { return "im April"; },
        May: function () { return "im Mai"; },
        Jun: function () { return "im Juni"; },
        Jul: function () { return "im Juli"; },
        Aug: function () { return "im August"; },
        Sep: function () { return "im September"; },
        Oct: function () { return "im Oktober"; },
        Nov: function () { return "im November"; },
        Dec: function () { return "Dezember"; }
    },
    ok: function () { return "bestimmt"; },
    now: function () { return "momentan"; },
    today: function () { return "Heute ist"; },
    day: function () { return "Der Tag"; },
    weekHeader: function () { return "Woche."; },
    month: function () { return "Der Monat"; },
    year: function () { return "Jahr"; },
    schedule: function () { return "Tagesordnung."; },
    allDay: function () { return "ganzen Tag"; },
    monthNames: {
        January: function () { return "im Januar"; },
        February: function () { return "im Februar"; },
        March: function () { return "März"; },
        April: function () { return "im April"; },
        May: function () { return "im Mai"; },
        June: function () { return "im Juni"; },
        July: function () { return "im Juli"; },
        August: function () { return "im August"; },
        September: function () { return "im September"; },
        October: function () { return "im Oktober"; },
        November: function () { return "im November"; },
        December: function () { return "Dezember"; }
    },
    startsWith: function () { return "Begonnen von"; },
    endsWith: function () { return "Beendet am"; },
    edit: function () { return "Redaktion"; },
    confirm: function () { return "Bestätigen"; },
    cancel: function () { return "Abgesagt."; },
    collapse_sidebar: function () { return "Schließe die Seitenleiste."; },
    expand_sidebar: function () { return "Öffnen Sie die Seitenleiste."; },
    expand: function () { return "beginnt"; },
    collapse: function () { return "Schließen."; },
    no_data: function () { return "Fehlende Daten"; },
    all_results_total: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "Das Ergebnis " + d.count; },
    per_page_item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "pro Seite " + d.count; },
    item: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "{" + d.count + "} Artikel schreiben"; },
    go_to_page: function (_d) { var d = (0, utils_1.reqArgs)(["number"], _d); return "Gehe zur " + d.number + " Seite"; },
    select_all: function () { return "Alle wählen wählen"; },
    clear: function () { return "Aufräumen"; },
    reset: function () { return "Ersatz durch"; },
    please_enter: function () { return "Bitte importieren."; },
    input_placeholder: function () { return "Bitte geben Sie den Kontext ein."; },
    phone_invalid: function () { return "Telefonformat falsch."; },
    phone: function () { return "Die Mobilnummer"; },
    please_select: function () { return "Bitte auswählen"; },
    upload_file: function () { return "Dokumente hochzuladen"; },
    upload_again: function () { return "wieder hochgeladen."; },
    uploading: function () { return "nach oben."; },
    upload_successful: function () { return "Hochladen mit Erfolg"; },
    upload_failed: function () { return "Hochladen gescheitert"; },
    click_upload: function () { return "Schlag hoch."; },
    drag_upload: function () { return "Klicken Sie auf die Region."; },
    more_filters: function () { return "Mehr Etiketten."; },
    empty: function () { return "leer sein"; },
    more: function () { return "mehr."; },
    more_labels: function () { return "Mehr Auswahl."; },
    selected_items: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "Auswahl " + d.count; },
    password_placeholder: function () { return "Bitte Code eingeben."; },
    preStep: function () { return "letzten Schritt."; },
    nextStep: function () { return "nächsten Schritt."; },
    formMessage: function (_d) { var d = (0, utils_1.reqArgs)(["content"], _d); return d.content + " Ein Fehler"; },
    upload_manager: {
        title: {
            in_progress: function () { return "nach oben."; },
            task_cancal: function () { return "Auftrag gestrichen"; },
            single: {
                succeeded: function () { return "Hochladen mit Erfolg"; },
                failed: function () { return "Hochladen gescheitert"; }
            },
            multiple: {
                all_succeeded: function () { return "Alles mit Erfolg."; },
                all_failed: function () { return "Alles zum Scheitern gebracht."; },
                partial_fail: function () { return "teilweise gescheitert."; },
                succeed: function () { return "Hochladen mit Erfolg"; },
                failed: function () { return "Hochladen gescheitert"; }
            }
        },
        actions: {
            cancel: function () { return "Abgesagt."; },
            cancel_all: function () { return "Alles abgesagt."; },
            retry: function () { return "wieder hochgeladen."; },
            error_and_retry: function () { return "Netzwerkfehler, erneut eingefügt."; },
            retry_all: function () { return "Alles versucht."; }
        },
        messages: {
            cancelled: function () { return "oben gestrichen."; },
            estimated_upload_time: function () { return "Voraussichtlich wird die Zeit übertragen."; },
            files_in_progress: function () { return "Ein Dokument wird gerade hochgeladen."; },
            files_failed: function () { return "Ein Dokument ist fehlgeschlagen."; },
            files_succeeded: function () { return "Es wurde ein Dokument hochgeladen."; },
            has_identical_files: function () { return "Ermitteln, ob ein Katalog denselben Inhalt enthält"; }
        }
    },
    emptyMessage: function () { return "Keine Auswahl"; },
    emptyMatchedMessage: function () { return "Keine passenden Daten"; },
    emptyFilterMessage: function () { return "Die Suchresultate sind leer"; },
    pleaseEnterSearchContent: function () { return "Bitte geben Sie den Suchinhalt ein."; },
    region: {
        China: function () { return "Chinesisches"; },
        HongKong: function () { return "Hongkong"; },
        Macao: function () { return "Macau"; },
        Taiwan: function () { return "Taiwan"; },
        America: function () { return "Vereinigten Staaten."; },
        Australia: function () { return "Australien"; },
        Singapore: function () { return "für Singapur"; }
    },
    download_manager: {
        title: {
            in_progress: function () { return "下载中"; },
            task_cancal: function () { return "任务取消"; },
            single: {
                succeeded: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            },
            multiple: {
                all_succeeded: function () { return "全部下载成功"; },
                all_failed: function () { return "全部下载失败"; },
                partial_fail: function () { return "部分下载失败"; },
                succeed: function () { return "下载成功"; },
                failed: function () { return "下载失败"; }
            }
        },
        actions: {
            cancel: function () { return "取消下载"; },
            cancel_all: function () { return "全部取消"; },
            retry: function () { return "重新下载"; },
            error_and_retry: function () { return "网络错误，重新下载"; },
            retry_all: function () { return "全部重试"; }
        },
        messages: {
            pending: function () { return "等待下载..."; },
            cancelled: function () { return "下载取消"; },
            estimated_download_time: function (_d) { var d = (0, utils_1.reqArgs)(["time"], _d); return "预计下载用时" + d.time; },
            files_in_progress: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件正在下载"; },
            files_failed: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return d.count + " 个文件下载失败"; },
            files_succeeded: function (_d) { var d = (0, utils_1.reqArgs)(["count"], _d); return "已下载 " + d.count + " 个文件"; },
            has_identical_files: function () { return "检测到目录中含相同内容文件"; }
        }
    }
};
